import { jsx, jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "../../../lib/utils.js";
import { QuizVideoPlayer } from "./quiz-video-player.js";
function isVideoMedia(media) {
  return !!((media == null ? void 0 : media.mimeType) && media.mimeType.startsWith("video/"));
}
function getMediaUrl(media) {
  if (!media) return null;
  if (isVideoMedia(media)) {
    return media.hls ?? media.signedUrl ?? media.url ?? null;
  }
  return media.signedUrl ?? media.url ?? null;
}
function QuizImage({
  image,
  imageMobile,
  className,
  alt
}) {
  const { t } = useTranslation("quiz");
  const imageAlt = alt ?? t("container.questionImage");
  const scaleStyle = useMemo(() => {
    if ((image == null ? void 0 : image.scaleX) || (image == null ? void 0 : image.scaleY)) {
      const scaleX = image.scaleX ?? 1;
      const scaleY = image.scaleY ?? 1;
      if (scaleX === scaleY && scaleX !== 1) {
        return { zoom: scaleX };
      }
    }
    return void 0;
  }, [image == null ? void 0 : image.scaleX, image == null ? void 0 : image.scaleY]);
  if (!image) return null;
  const isVideo = isVideoMedia(image);
  const videoUrl = getMediaUrl(image);
  const imageUrl = getMediaUrl(image);
  const mobileImageUrl = getMediaUrl(imageMobile);
  const hasHls = !!(image == null ? void 0 : image.hls);
  if (isVideo && videoUrl) {
    return /* @__PURE__ */ jsx("div", { className: cn("flex justify-center my-4", className), children: /* @__PURE__ */ jsx(
      QuizVideoPlayer,
      {
        src: videoUrl,
        mimeType: image.mimeType,
        isHls: hasHls,
        className: "overflow-hidden"
      }
    ) });
  }
  if (!imageUrl) return null;
  if (mobileImageUrl && mobileImageUrl !== imageUrl) {
    return /* @__PURE__ */ jsxs("div", { className: cn("flex justify-center my-4", className), children: [
      /* @__PURE__ */ jsx(
        "img",
        {
          src: mobileImageUrl,
          alt: imageAlt,
          className: "block max-w-full h-auto md:hidden",
          style: scaleStyle,
          referrerPolicy: "no-referrer"
        }
      ),
      /* @__PURE__ */ jsx(
        "img",
        {
          src: imageUrl,
          alt: imageAlt,
          className: "hidden max-w-full h-auto md:block",
          style: scaleStyle,
          referrerPolicy: "no-referrer"
        }
      )
    ] });
  }
  return /* @__PURE__ */ jsx("div", { className: cn("flex justify-center my-4", className), children: /* @__PURE__ */ jsx(
    "img",
    {
      src: imageUrl,
      alt: imageAlt,
      className: "max-w-full h-auto",
      style: scaleStyle,
      referrerPolicy: "no-referrer"
    }
  ) });
}
export {
  QuizImage
};
//# sourceMappingURL=quiz-image.js.map
